import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
} from 'react';

import {useNavigate} from 'react-router-dom';

import {useUsersRepository} from '@/dataSource/src/api/users/useRepository';

import {DEFAULT_CARD} from '../../constants/OnboardingConstants';

type VirtualCardReadyViewModelContextType = {
  cardTheme: string;
  handleButtonAction: () => void;
};

const VirtualCardReadyViewModelContext = createContext<
  VirtualCardReadyViewModelContextType | undefined
>(undefined);

export function VirtualCardReadyViewModelProvider({
  children,
}: {
  children: ReactNode;
}) {
  //#region [---- [PROPERTIES] ----]
  const navigate = useNavigate();
  const {profile} = useUsersRepository();
  const cardThemeSelected =
    profile?.metadata?.ONBOARDING_CARD_THEME_SELECTED || DEFAULT_CARD;
  //#endregion

  //#region [---- [HOOKS] ----]
  const cardTheme = useMemo(
    () => `/assets/images/cards/MoVirtualCard-${cardThemeSelected}.webp`,
    [cardThemeSelected],
  );
  //#endregion

  //#region [---- [LOGIC] ----]
  const handleButtonAction = useCallback(() => {
    navigate('/onboarding/download-app');
  }, [navigate]);
  //#endregion

  return (
    <VirtualCardReadyViewModelContext.Provider
      value={{cardTheme, handleButtonAction}}>
      {children}
    </VirtualCardReadyViewModelContext.Provider>
  );
}

export function useVirtualCardReadyViewModelProvider() {
  const context = useContext(VirtualCardReadyViewModelContext);
  if (context === undefined) {
    throw new Error('Virtual Card Ready ViewModelContext is undefined');
  }
  return context;
}
